import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "mb-16" }, " Please name your asset e.g. EXT13_Pool Deck ", -1 /* HOISTED */)
const _hoisted_2 = { class: "form__set" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", {
  for: "new_tag",
  class: "form__label form__label--large form__label--emphasised"
}, " Code ", -1 /* HOISTED */)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "form__label form__label--emphasised" }, " Select the code prefix and enter a number (letters allowed if required e.g. 13A) ", -1 /* HOISTED */)
const _hoisted_5 = { class: "flex flex--gap-medium" }
const _hoisted_6 = { class: "form__icon form__icon--down" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: "",
  selected: ""
}, " Select ", -1 /* HOISTED */)
const _hoisted_8 = ["value", "disabled"]
const _hoisted_9 = ["value", "disabled"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", {
  for: "new_tag",
  class: "form__label form__label--large form__label--emphasised"
}, " Title ", -1 /* HOISTED */)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "form__label form__label--emphasised" }, " Enter a descriptive title for the asset. Letters and numbers only e.g. Apartment 2 Dining Room ", -1 /* HOISTED */)
const _hoisted_12 = ["value", "disabled"]
const _hoisted_13 = {
  key: 0,
  class: "error-message"
}
const _hoisted_14 = ["disabled"]
const _hoisted_15 = ["disabled"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock($setup["SimpleModalComponent"], {
    heading: "Add asset",
    onCloseModal: _cache[1] || (_cache[1] = $event => ($setup.emit( 'close-modal' )))
  }, {
    content: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _withDirectives(_createElementVNode("select", {
              id: "code-prefix",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($setup.code_prefix) = $event)),
              class: _normalizeClass(["form__select", { 'form__select--error': $setup.errors.code_prefix }])
            }, [
              _hoisted_7,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.possible_code_prefixes, (prefix) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: `prefix-${ prefix }`,
                  value: prefix,
                  disabled: $setup.loading
                }, _toDisplayString(prefix), 9 /* TEXT, PROPS */, _hoisted_8))
              }), 128 /* KEYED_FRAGMENT */))
            ], 2 /* CLASS */), [
              [_vModelSelect, $setup.code_prefix]
            ])
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["form__set form__set--no-margin", { 'form__set--error': $setup.errors.code_number }])
          }, [
            _createElementVNode("input", {
              id: "code-number",
              value: $setup.code_number,
              class: "form__input",
              type: "text",
              name: "title",
              placeholder: "",
              disabled: $setup.loading,
              onInput: $setup.validateCodeInput
            }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_9)
          ], 2 /* CLASS */)
        ])
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["form__set", { 'form__set--error': $setup.errors.title }])
      }, [
        _hoisted_10,
        _hoisted_11,
        _createElementVNode("input", {
          id: "title",
          value: $setup.title,
          class: "form__input form__input--stretch",
          type: "text",
          name: "title",
          placeholder: "",
          disabled: $setup.loading,
          onInput: $setup.validateTitleInput
        }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_12)
      ], 2 /* CLASS */),
      ($setup.error_message)
        ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString($setup.error_message), 1 /* TEXT */))
        : _createCommentVNode("v-if", true)
    ]),
    buttons: _withCtx(() => [
      _createElementVNode("button", {
        class: "button",
        disabled: $setup.loading,
        onClick: $setup.closeModal
      }, " Cancel ", 8 /* PROPS */, _hoisted_14),
      _createElementVNode("button", {
        class: _normalizeClass(["button button--fill", { 'button--loading' : $setup.loading }]),
        disabled: $setup.loading,
        onClick: $setup.createNewAsset
      }, " Add ", 10 /* CLASS, PROPS */, _hoisted_15)
    ]),
    _: 1 /* STABLE */
  }))
}